import { render, staticRenderFns } from "./Juridica.vue?vue&type=template&id=1f38f05a&scoped=true&"
import script from "./Juridica.vue?vue&type=script&lang=js&"
export * from "./Juridica.vue?vue&type=script&lang=js&"
import style0 from "./Juridica.vue?vue&type=style&index=0&id=1f38f05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38f05a",
  null
  
)

export default component.exports